import { supabase } from '../../lib/supabaseClient';

export type Video = {
  id: string;
  title_en: string;
  title_th: string | null;
  youtube_url: string;
  thumbnail_url: string | null;
  is_featured: boolean;
  sort_order: number;
  created_at?: string;
  updated_at?: string;
};

export async function getVideos() {
  const { data, error } = await supabase
    .from('videos')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as Video[];
}

export async function getFeaturedVideos() {
  const { data, error } = await supabase
    .from('videos')
    .select('*')
    .eq('is_featured', true)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as Video[];
}

export async function createVideo(payload: Partial<Video>) {
  const { data, error } = await supabase.from('videos').insert(payload).select('id').single();
  if (error) throw error;
  return data.id as string;
}

export async function updateVideo(id: string, payload: Partial<Video>) {
  const { error } = await supabase.from('videos').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deleteVideo(id: string) {
  const { error } = await supabase.from('videos').delete().eq('id', id);
  if (error) throw error;
}

export function getYoutubeEmbedUrl(url: string): string {
  const trimmed = url.trim();
  const match = trimmed.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  const id = match ? match[1] : trimmed;
  return `https://www.youtube.com/embed/${id}`;
}

export function getYoutubeThumbnailUrl(url: string): string {
  const trimmed = url.trim();
  const match = trimmed.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  const id = match ? match[1] : trimmed;
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}
